<template>

    <Toast/>

    <MenuSiModuleMain/>
    <!--    <HeadingAppointments/>-->

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Plan</h3>

                    <div class="field">
                        <span>Functionality not available with current subscription. Please upgrade to view functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Plan</h3>

                    <div class="field">
                        <span>Future enhancement coming soon, will provide personalized planning functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 3" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Plan</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callSetGoals" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Set Goals</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlist" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Watchlist</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlistAdd" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Add Watchlist Item</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlistDelete" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Remove Watchlist Item</span>
                                </a>
                            </li>
<!--                            <li>-->
<!--                                <a @click="callOverview" v-ripple-->
<!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                                    <i class="pi pi-info-circle mr-2"></i>-->
<!--                                    <span>Back to Home</span>-->
<!--                                </a>-->
<!--                            </li>-->
                        </ul>
                    </div>

                    <div class="field">
                        <label for="freedomGoal">My annual financial freedom income goal</label>
                        <InputNumber
                            id="amount"
                            v-model="userConfiguration.siFreedomGoal"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="0"/>
                    </div>

                    <div class="field">
                        <label for="freedomYear">My financial freedom year</label>
                        <Dropdown v-model="userConfiguration.siFreedomYear"
                                  :options="years"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>

                    </div>

                    <div class="field">
                        <label for="currency">My base currency</label>
                        <Dropdown v-model="userConfiguration.siPlanCurrency"
                                  :options="currencyTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Currency"/>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="savePlanConfiguration"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 4" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Watchlist</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callSetGoals" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Set Goals</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlist" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Watchlist</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlistAdd" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Add Watchlist Item</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlistDelete" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Remove Watchlist Item</span>
                                </a>
                            </li>
<!--                            <li>-->
<!--                                <a @click="callOverview" v-ripple-->
<!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                                    <i class="pi pi-info-circle mr-2"></i>-->
<!--                                    <span>Back to Home</span>-->
<!--                                </a>-->
<!--                            </li>-->
                        </ul>
                    </div>


                    <div class="grid" v-show="this.loading === true">
                        <ProgressSpinner v-if="loading" style="width: 16px; height: 16px" strokeWidth="6"
                                         fill="transparent"
                                         animationDuration=".5s" aria-label="Custom ProgressSpinner"/>
                    </div>

                    <div class="grid" v-show="this.loading === false">
                        &nbsp;
                    </div>

                    <DataTable
                        :value="stockData"
                        :scrollable="true" scrollHeight="500px" scrollDirection="both"
                        :loading="loading"
                        v-model:filters="filters"
                        filterDisplay="menu"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :rowHover="true"
                        :sortMode="'multiple'"
                        dataKey="id"
                        class="p-datatable-gridlines"
                        :globalFilterFields="['codeId129', 'companyNameId046']">

                        <template #header>
                            <div class="col-12">
                                <div class="card p-fluid">
                                    <div class="grid">

                                        <div class="col-12 lg:col-2 p-3">
                                            <Dropdown
                                                v-model="selectedExchange"
                                                :options="exchanges"
                                                optionLabel="name"
                                                optionValue="code"
                                                placeholder="Select an Exchange"
                                                @change="onExchangeChange"/>
                                        </div>

                                        <!--                                        <div class="col-12 lg:col-2 p-3">-->
                                        <!--                                            <Dropdown-->
                                        <!--                                                v-model="selectedTimePeriod"-->
                                        <!--                                                :options="timePeriods"-->
                                        <!--                                                optionLabel="name"-->
                                        <!--                                                optionValue="code"-->
                                        <!--                                                placeholder="Select an Exchange"-->
                                        <!--                                                @change="onTimePeriodChange"/>-->
                                        <!--                                        </div>-->

                                        <div class="col-12 lg:col-4 p-3">
                                            <MultiSelect
                                                :modelValue="selectedColumns"
                                                :options="columnConfig"
                                                optionLabel="header"
                                                @update:modelValue="onToggleColumns"
                                                display="chip"
                                                placeholder="Select Columns"
                                            />
                                        </div>

                                        <div class="col-12 lg:col-2 p-3">
                                            <Dropdown v-model="selectedFormat" :options="formats"
                                                      optionLabel="name" optionValue="code"
                                                      placeholder="Select a Format"
                                                      @change="onFormatChange"/>
                                        </div>

                                        <div class="col-12 lg:col-4 p-3">
                                            <span class="p-input-icon-left">
                                                <i class="pi pi-search"/>
                                                <InputText v-model="filters['global'].value"
                                                           placeholder="Find stocks in current table"
                                                           style="width: 100%" maxlength="100"/>
                                            </span>
                                        </div>

                                    </div>

                                    <!--                                        <div class="col-12 lg:col-2 p-3">-->
                                    <!--                                            <Button type="button" icon="pi pi-replay" label="Restore to Original View"-->
                                    <!--                                                    class="p-button-outlined" @click="restoreToOriginal()"/>-->
                                    <!--                                        </div>-->

                                </div>
                            </div>

                        </template>

                        <template #empty>
                            No stock data found.
                        </template>

                        <template #loading>
                            Loading stock data. Please wait.
                        </template>

                        <Column
                            v-for="column in filteredColumns"
                            :key="column.field"
                            :field="column.field"
                            :sortable="column.sortable"
                            :style="column.style"
                            :frozen="column.frozen || false">

                            <template #header>
                                <span v-if="( (column.field === 'averageEpsGrowthYear20Id018') ||
                                    (column.field === 'averageEpsGrowthYear15Id017') ||
                                    (column.field === 'averageEpsGrowthYear10Id016') ||
                                    (column.field === 'averageEpsGrowthYear5Id015') )" v-tooltip="'[8% or more]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="( (column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                    (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                    (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                    (column.field === 'undervaluedVsOvervaluedStatusYear5Id132') )"
                                      v-tooltip="'[undervalued]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="( (column.field === 'adgYear20Id009') ||
                                    (column.field === 'adgYear15Id008') ||
                                    (column.field === 'adgYear10Id007') ||
                                    (column.field === 'adgYear5Id006') )" v-tooltip="'[8% or more]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="(column.field === 'pbRatioId102')" v-tooltip="'[3 or less]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="(column.field === 'peRatioId104')" v-tooltip="'[25 or less]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="(column.field === 'shareBuybackId122')" v-tooltip="'[yes]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="(column.field === 'afdPreviousId005')" v-tooltip="'[0% or more]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')"
                                      v-tooltip="'[70% or less]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="(column.field === 'payoutRatioId107')" v-tooltip="'[75% or less]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="(column.field === 'epsIncreasesYear20Id097')"
                                      v-tooltip="'[8 or more]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="(column.field === 'epsIncreasesYear15Id096')"
                                      v-tooltip="'[6 or more]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="(column.field === 'epsIncreasesYear10Id095')"
                                      v-tooltip="'[4 or more]'">
                                    {{ column.header }}
                                </span>
                                <span v-else-if="(column.field === 'epsIncreasesYear5Id094')" v-tooltip="'[2 or more]'">
                                    {{ column.header }}
                                </span>
                                <span v-else>
                                    {{ column.header }}
                                </span>
                            </template>

                            <template #body="{ data }">

                            <span v-if="column.field === 'codeId129'">
                                <a href="javascript:void(0)" @click="onCompanyCodeClick(data)">
                                    {{ data[column.field] }}
                                </a>
                            </span>

                                <span v-else-if="column.field === 'sharePriceId123'">
                                    {{ formatAmount(data[column.field]) }}
                                </span>

                                <span v-else-if="column.field === 'currentDividendYieldId050'">
                                    {{ formatAmount(data[column.field]) }}%

<!--                                    <span v-if="((data[column.field] > maxDividendYield) &&-->
<!--                                        ((this.selectedExchange != 'DOW30') && (this.selectedExchange != 'TSX60')))"-->
<!--                                          :class="'status-badge status-DT'"-->
<!--                                          @click="handleDTClick(data)">DT-->
<!--                                    </span>-->

                                </span>

                                <span v-else-if="( (column.field === 'siCriteriaYear20Id128') ||
                                    (column.field === 'siCriteriaYear15Id127') ||
                                    (column.field === 'siCriteriaYear10Id126') ||
                                    (column.field === 'siCriteriaYear5Id125') )">
                                    {{ data[column.field] }}
                                </span>

                                <span v-else-if="column.field === 'companyNameId046'">
                                    {{ data[column.field] }}
                                </span>

                                <span v-else-if="( (column.field === 'averageEpsGrowthYear20Id018') ||
                                    (column.field === 'averageEpsGrowthYear15Id017') ||
                                    (column.field === 'averageEpsGrowthYear10Id016') ||
                                    (column.field === 'averageEpsGrowthYear5Id015') )">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="data[column.field] >= 8">
                                        {{ formatAmount(data[column.field]) }}%
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}%
                                    </span>
                                </span>

                                <span v-else-if="( (column.field === 'epsIncreasesYear20Id097') ||
                                    (column.field === 'epsIncreasesYear15Id096') ||
                                    (column.field === 'epsIncreasesYear10Id095') ||
                                    (column.field === 'epsIncreasesYear5Id094') )">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="data[column.field] >= 8">
                                        {{ formatNumeric(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatNumeric(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="( (column.field === 'adgYear20Id009') ||
                                    (column.field === 'adgYear15Id008') ||
                                    (column.field === 'adgYear10Id007') ||
                                    (column.field === 'adgYear5Id006') )">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="data[column.field] >= 8">
                                        {{ formatAmount(data[column.field]) }}%
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}%
                                    </span>
                                </span>

                                <span v-else-if="(column.field === 'payoutRatioId107')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="((data[column.field] > 0) && (data[column.field] <= 75))">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="(column.field === 'longtermDebtEquityRatioId084')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="((data[column.field] >= 0) && (data[column.field] <= 70))">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="(column.field === 'afdPreviousId005')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="(data[column.field] > 0)">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="(column.field === 'shareBuybackId122')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="(data[column.field] === 'Y')">Yes</span>
                                    <span v-else :class="'highlight'">No</span>
                                </span>

                                <span v-else-if="(column.field === 'peRatioId104')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="((data[column.field] > 0) && (data[column.field] <= 25))">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="((column.field === 'undervaluedVsOvervaluedStatusYear20Id135') ||
                                            (column.field === 'undervaluedVsOvervaluedStatusYear15Id134') ||
                                            (column.field === 'undervaluedVsOvervaluedStatusYear10Id133') ||
                                            (column.field === 'undervaluedVsOvervaluedStatusYear5Id132'))">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="(data[column.field] === 'U')">Under-valued</span>
                                    <span v-else :class="'highlight'">Over-valued</span>
                                </span>

                                <span v-else-if="(column.field === 'pbRatioId102')">
                                    <span v-if="data[column.field] === -9999.0" :class="'highlight'">N/A</span>
                                    <span v-else-if="((data[column.field] > 0) && (data[column.field] <= 3))">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                    <span v-else :class="'highlight'">
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                                <!--                                <span v-else-if="(column.field === 'yearsDividendIncreasesId047')">-->
                                <!--                                    <span v-if="data[column.field] === -9999.0">N/A</span>-->
                                <!--                                    <span v-else>-->
                                <!--                                        {{ formatNumeric(data[column.field]) }}-->
                                <!--                                    </span>-->
                                <!--                                </span>-->

                                <!--                                <span v-else-if="(column.field === 'yearsEpsIncreasesId048')">-->
                                <!--                                    <span v-if="data[column.field] === -9999.0">N/A</span>-->
                                <!--                                    <span v-else>-->
                                <!--                                        {{ formatNumeric(data[column.field]) }}-->
                                <!--                                    </span>-->
                                <!--                                </span>-->

                                <span v-else-if="((column.field === 'yearsDividendIncreasesId047') ||
                                        (column.field === 'yearsEpsIncreasesId048') ||
                                        (column.field === 'employeesId093') ||
                                        (column.field === 'epsIncreasesYear5Id094') ||
                                        (column.field === 'epsIncreasesYear10Id095') ||
                                        (column.field === 'epsIncreasesYear15Id096') ||
                                        (column.field === 'epsIncreasesYear20Id097') )">
                                    <span v-if="data[column.field] === -9999.0">N/A</span>
                                    <span v-else>
                                        {{ formatNumeric(data[column.field]) }}
                                    </span>
                                </span>

                                <span v-else-if="((column.field === 'companyAddressCityId041') ||
                                        (column.field === 'companyAddressCountryId042') ||
                                        (column.field === 'companyAddressStateId043') ||
                                        (column.field === 'companyAddressId044') ||
                                        (column.field === 'companyDescriptionId045') ||
                                        (column.field === 'industryId081') ||
                                        (column.field === 'marketId089') ||
                                        (column.field === 'sectorId121') ||
                                        (column.field === 'websiteId136') ||
                                        (column.field === 'dividendCurrencyId062') ||
                                        (column.field === 'dividendFrequencyId063') ||
                                        (column.field === 'dividendPaymentDateId068') ||
                                        (column.field === 'dividendRecordDateId069') ||
                                        (column.field === 'exDividendDateId074') ||
                                        (column.field === 'fiscalYearendDateId075') ||
                                        (column.field === 'dividendPaidId070') ||
                                        (column.field === 'sharePriceDateId124') )">
                                        {{ data[column.field] }}
                                </span>

                                <span v-else>
                                    <span v-if="data[column.field] === -9999.0">N/A</span>
                                    <span v-else-if="data[column.field] === -999999.00">N/A</span>
                                    <span v-else>
                                        {{ formatAmount(data[column.field]) }}
                                    </span>
                                </span>

                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 5" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Dividend Trap</h3>

                    <span>
                        View the video below, to learn how to identify and avoid dividend traps.

                        <br/><br/>
                        You are on this page because you've clicked on the text "DT" within a cell in the stock tables.

                        <br/><br/>
                        "DT" represents a stock that might be a possible Dividend Trap, these types of stocks are to be avoided.

                        <br/><br/>
                        What is a Dividend Trap?
                        <br/>
                        A dividend trap is a too-good-to-be-true dividend yield (that's typically very high) that's unsustainable. There is a high risk that the dividend will be reduced or eliminated.

                        <br/><br/>
                        How to Avoid a Dividend Trap?
                        <br/>
                        As explained in the video above, the best way to avoid a dividend trap is to avoid investing in a stock with a very high dividend yield.

                        <br/><br/>
                        How does the SI Platform Identify Possible Dividend Traps for US Stocks?
                        <br/>
                        The SI Platform performs the following four actions:
                        <br/>
                        1. It will calculate the average current dividend yield of all Top Ranked and Runners-Up US stocks
                        <br/>
                        2. It will then multiply the above value (from Step 1) by 2.5 times, the resulting value is called the "maximum dividend yield"
                        <br/>
                        3. Any stock that exceeds the "maximum dividend yield" will be indentified as a possible "Dividend Trap"
                        <br/>
                        4. Any possible "Dividend Trap" will have it's current dividend yield displayed in bold, it's cell will be highlighted in orange, and the text "DT" will be displayed next to the current dividend yield value

                        <br/><br/>
                        How does the SI Platform Identify Possible Dividend Traps for Canadian Stocks?
                        <br/>
                        The SI Platform performs the following four actions:
                        <br/>
                        1. It will calculate the average current dividend yield of all Top Ranked and Runners-Up Canadian stocks
                        <br/>
                        2. It will then multiply the above value (from Step 1) by 2.5 times, the resulting value is called the "maximum dividend yield"
                        <br/>
                        3. Any stock that exceeds the "maximum dividend yield" will be indentified as a possible "Dividend Trap"
                        <br/>
                        4. Any possible "Dividend Trap" will have it's current dividend yield displayed in bold, it's cell will be highlighted in orange, and the text "DT" will be displayed next to the current dividend yield value
                    </span>

                    <div class="col-12 md:col-6 lg:col-4">
                        <div class="p-2">
                            <div class="shadow-2 p-4 surface-card border-round">

                                <div style="padding:56.25% 0 0 0;position:relative;">
                                    <!--                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/SsOno5z_hl0?si=2usedkTiFE9ngz7a" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>-->

                                    <iframe
                                        src="https://www.youtube.com/embed/SsOno5z_hl0?si=2usedkTiFE9ngz7a"
                                        frameborder="0"
                                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                        style="position:absolute;top:0;left:0;width:100%;height:100%;"
                                        title="893379528-lesson1"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>


                    <Button label="Back" class="mr-2 mb-2" @click="callSetGoals"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 6" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="col-12">
                        <div class="card">
                            <h3>Stock Data for {{ this.specificStockData.companyNameId046 }}</h3>

                            <div class="col-12">
                                <div class="card">
                                    <Button label="Back" class="mr-2 mb-2" @click="callOverviewWatchList"></Button>
                                </div>
                            </div>

                            <h3>Key Information for {{ this.specificStockData.companyNameId046 }}</h3>

                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-4">
                                    <label for="codeId129" style="font-weight: bold;">Stock Symbol</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.codeId129 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="lastname2" style="font-weight: bold;">Currency</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.dividendCurrencyId062 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="epsTtmId071" style="font-weight: bold;">EPS (TTM)</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.epsTtmId071) }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="sharePriceId123" style="font-weight: bold;">Share Price</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.sharePriceId123 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="exchangeId073" style="font-weight: bold;">Exchange</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.exchangeId073 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="payoutRatioId107" style="font-weight: bold;">Payout Ratio</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.payoutRatioId107) }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="sharePriceDateId124" style="font-weight: bold;">Share Price Date</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.sharePriceDateId124 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="peRatioId104" style="font-weight: bold;">PE Ratio (TTM)</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.peRatioId104) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="longtermDebtEquityRatioId084" style="font-weight: bold;">Long-term
                                        Debt/Equity Ratio</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.longtermDebtEquityRatioId084) }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="afdId004" style="font-weight: bold;">Forward Annual Dividend</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.afdId004) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="pbRatioId102" style="font-weight: bold;">PB Ratio (TTM)</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.pbRatioId102) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="dividendPaidId070" style="font-weight: bold;">Dividends Paid
                                        Since</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.dividendPaidId070 }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="firstname2" style="font-weight: bold;">Dividend Yield</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.currentDividendYieldId050) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="marketCapitalisationId090" style="font-weight: bold;">Market
                                        Capitalization</label>
                                    <br/>
                                    <span>
                                        {{ formatAmount(this.specificStockData.marketCapitalisationId090) }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="shareBuybackId122" style="font-weight: bold;">Share Buyback?</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.shareBuybackId122 }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="employeesId093" style="font-weight: bold;">Number of Employees</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.employeesId093 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="industryId081" style="font-weight: bold;">Industry</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.industryId081 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="undervaluedVsOvervaluedStatusYear20Id135" style="font-weight: bold;">Undervalued/overvalued
                                        (20-yr)</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.undervaluedVsOvervaluedStatusYear20Id135 }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-4">
                                    <label for="address" style="font-weight: bold;">Address</label>
                                    <br/>
                                    <span>
                                        {{
                                            this.specificStockData.companyAddressId044 + ', ' +
                                            this.specificStockData.companyAddressCityId041 + ' ' +
                                            this.specificStockData.companyAddressStateId043 + ' ' +
                                            this.specificStockData.companyAddressCountryId042
                                        }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="websiteId136" style="font-weight: bold;">Website</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.websiteId136 }}
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label for="siCriteriaYear20Id128" style="font-weight: bold;">SI Criteria
                                        (20-yr)</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.siCriteriaYear20Id128 }}
                                    </span>
                                </div>

                                <div class="field col-12">&nbsp;</div>

                                <div class="field col-12 md:col-12">
                                    <label for="companyDescriptionId045" style="font-weight: bold;">Company
                                        Description</label>
                                    <br/>
                                    <span>
                                        {{ this.specificStockData.companyDescriptionId045 }}
                                    </span>
                                </div>

                            </div>

                            <div class="field col-12">&nbsp;</div>

                        </div>
                    </div>


                    <div class="col-12">
                        <div class="card">
                            <h3>Stock History for {{ this.specificStockData.companyNameId046 }}</h3>

                            <DataTable
                                :value="stockHistory"
                                :striped-rows="true"
                                :reorderableColumns="true"
                                :rowHover="true"
                                :sortMode="'multiple'"
                                dataKey="id"
                                class="p-datatable-gridlines">

                                <template #empty>
                                    No stock history found.
                                </template>

                                <!--                                <template #loading>-->
                                <!--                                    Loading stock history. Please wait.-->
                                <!--                                </template>-->

                                <Column field="year" header="Year" :sortable="true"
                                        style="max-width: 200px; min-width: 200px"
                                        frozen>
                                    <template #body="{data}">
                                        {{ data.year }}
                                    </template>
                                </Column>

                                <!--                                <Column field="dividendPerShare" header="Dividend Per Share" style="max-width: 200px; min-width: 200px"-->
                                <!--                                        :sortable="true">-->
                                <!--                                    <template #body="{data}">-->
                                <!--                                        {{ formatAmount(data.dividendPerShare) }}-->
                                <!--                                    </template>-->
                                <!--                                </Column>-->

                                <Column field="dividendPerShare" header="Dividend Per Share" :sortable="true"
                                        style="max-width: 80px; min-width: 80px; text-align: right;">
                                    <template #body="{data}">
                                        {{ formatAmount(data.dividendPerShare) }}
                                    </template>
                                </Column>

                                <Column field="averageDividendYield" header="Average Dividend Yield"
                                        style="max-width: 200px; min-width: 200px"
                                        :sortable="true">
                                    <template #body="{data}">
                                        {{ formatAmount(data.averageDividendYield) }}%
                                    </template>
                                </Column>

                                <Column field="eps" header="EPS" style="max-width: 200px; min-width: 200px"
                                        :sortable="true">
                                    <template #body="{data}">
                                        {{ formatAmount(data.eps) }}
                                    </template>
                                </Column>

                                <Column field="averagePeRatio" header="Average P/E Ratio"
                                        style="max-width: 200px; min-width: 200px"
                                        :sortable="true">
                                    <template #body="{data}">
                                        {{ formatAmount(data.averagePeRatio) }}
                                    </template>
                                </Column>

                            </DataTable>

                            <div class="field col-12">&nbsp;</div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="card">
                            <h3>SI Criteria for {{ this.specificStockData.companyNameId046 }}</h3>

                            <DataTable
                                :value="specificStockDataArray"
                                :scrollable="true" scrollHeight="500px" scrollDirection="both"
                                :loading="loading"
                                :striped-rows="true"
                                :reorderableColumns="true"
                                :rowHover="true"
                                :sortMode="'multiple'"
                                dataKey="id"
                                class="p-datatable-gridlines">

                                <template #header>
                                    <div class="col-12">
                                        <div class="card p-fluid">
                                            <div class="grid">

                                                <div class="col-12 lg:col-2 p-3">
                                                    <Dropdown v-model="selectedFormat" :options="formats"
                                                              optionLabel="name" optionValue="code"
                                                              placeholder="Select a Format"
                                                              @change="onFormatChange"/>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </template>

                                <template #empty>
                                    No stock data found.
                                </template>

                                <template #loading>
                                    Loading stock data. Please wait.
                                </template>

                                <Column field="codeId129" header="Stock Symbol" :sortable="true"
                                        style="max-width: 200px; min-width: 200px"
                                        frozen>
                                    <template #body="{data}">
                                        {{ data.codeId129 }}
                                    </template>
                                </Column>

                                <Column field="sharePriceId123" header="Share Price"
                                        style="max-width: 200px; min-width: 200px"
                                        :sortable="true"/>

                                <Column field="currentDividendYieldId050" header="Current Div Yld"
                                        style="max-width: 200px; min-width: 200px"
                                        :sortable="true">
                                    <template #body="{data}">
                                        {{ formatAmount(data.currentDividendYieldId050) }}
                                    </template>
                                </Column>


                                <Column v-if="(this.selectedTimePeriod === '20')" field="siCriteriaYear20Id128"
                                        header="SI Criteria out of 10 (20yr Data)"
                                        :sortable="true" style="max-width: 200px; min-width: 200px"/>

                                <Column v-if="(this.selectedTimePeriod === '15')" field="siCriteriaYear15Id127"
                                        header="SI Criteria out of 10 (15yr Data)"
                                        :sortable="true" style="max-width: 200px; min-width: 200px"/>

                                <Column v-if="(this.selectedTimePeriod === '10')" field="siCriteriaYear10Id126"
                                        header="SI Criteria out of 10 (10yr Data)"
                                        :sortable="true" style="max-width: 200px; min-width: 200px"/>

                                <Column v-if="(this.selectedTimePeriod === '5')" field="siCriteriaYear5Id125"
                                        header="SI Criteria out of 10 (5yr Data)"
                                        :sortable="true" style="max-width: 200px; min-width: 200px"/>


                                <Column v-if="this.selectedFormat === 'Complete'" field="companyNameId046"
                                        header="Name" style="max-width: 500px; min-width: 500px" :sortable="true">
                                    <template #body="{data}">
                                        <span class="p-column-title">Name</span>
                                        <span>
                                  {{ this.formatString(data.companyNameId046) }}
                                </span>
                                    </template>
                                </Column>


                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '20')"
                                    field="averageEpsGrowthYear20Id018"
                                    header="R5a – Avg EPS Growth 20yr" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R5a – Avg EPS Growth 20yr</span>
                                        <span v-if="data.averageEpsGrowthYear20Id018 >= 8">
                                  {{ this.formatAmount(data.averageEpsGrowthYear20Id018) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.averageEpsGrowthYear20Id018) }}
                                </span>
                                    </template>
                                </Column>

                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '15')"
                                    field="averageEpsGrowthYear15Id017"
                                    header="R5a – Avg EPS Growth 15yr" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R5a – Avg EPS Growth 15yr</span>
                                        <span v-if="data.averageEpsGrowthYear15Id017 >= 8">
                                  {{ this.formatAmount(data.averageEpsGrowthYear15Id017) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.averageEpsGrowthYear15Id017) }}
                                </span>
                                    </template>
                                </Column>

                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '10')"
                                    field="averageEpsGrowthYear10Id016"
                                    header="R5a – Avg EPS Growth 10yr" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R5a – Avg EPS Growth 10yr</span>
                                        <span v-if="data.averageEpsGrowthYear10Id016 >= 8">
                                  {{ this.formatAmount(data.averageEpsGrowthYear10Id016) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.averageEpsGrowthYear10Id016) }}
                                </span>
                                    </template>
                                </Column>

                                <Column v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '5')"
                                        field="averageEpsGrowthYear5Id015"
                                        header="R5a – Avg EPS Growth 5yr" :sortable="true"
                                        style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R5a – Avg EPS Growth 5yr</span>
                                        <span v-if="data.averageEpsGrowthYear5Id015 >= 8">
                                  {{ this.formatAmount(data.averageEpsGrowthYear5Id015) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.averageEpsGrowthYear5Id015) }}
                                </span>
                                    </template>
                                </Column>


                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '20')"
                                    field="epsIncreasesYear20Id097"
                                    header="R5b – EPS Increases in 20yrs" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R5b – EPS Increases in 20yrs</span>
                                        <span v-if="data.epsIncreasesYear20Id097 >= 8">
                                  {{ this.formatAmount(data.epsIncreasesYear20Id097) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.epsIncreasesYear20Id097) }}
                                </span>
                                    </template>
                                </Column>

                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '15')"
                                    field="epsIncreasesYear15Id096"
                                    header="R5b – EPS Increases in 15yrs" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R5b – EPS Increases in 15yrs</span>
                                        <span v-if="data.epsIncreasesYear15Id096 >= 8">
                                  {{ this.formatAmount(data.epsIncreasesYear15Id096) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.epsIncreasesYear15Id096) }}
                                </span>
                                    </template>
                                </Column>

                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '10')"
                                    field="epsIncreasesYear10Id095"
                                    header="R5b – EPS Increases in 10yrs" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R5b – EPS Increases in 10yrs</span>
                                        <span v-if="data.epsIncreasesYear10Id095 >= 8">
                                  {{ this.formatAmount(data.epsIncreasesYear10Id095) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.epsIncreasesYear10Id095) }}
                                </span>
                                    </template>
                                </Column>

                                <Column v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '5')"
                                        field="epsIncreasesYear5Id094"
                                        header="R5b – EPS Increases in 5yrs" :sortable="true"
                                        style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R5b – EPS Increases in 5yrs</span>
                                        <span v-if="data.epsIncreasesYear5Id094 >= 8">
                                  {{ this.formatAmount(data.epsIncreasesYear5Id094) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.epsIncreasesYear5Id094) }}
                                </span>
                                    </template>
                                </Column>


                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '20')"
                                    field="adgYear20Id009"
                                    header="R6 – Avg Div Growth 20yr" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R6 – Avg Div Growth 20yr</span>
                                        <span v-if="data.adgYear20Id009 >= 8">
                                  {{ this.formatAmount(data.adgYear20Id009) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.adgYear20Id009) }}
                                </span>
                                    </template>
                                </Column>

                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '15')"
                                    field="adgYear15Id008"
                                    header="R6 – Avg Div Growth 15yr" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R6 – Avg Div Growth 15yr</span>
                                        <span v-if="data.adgYear15Id008 >= 8">
                                  {{ this.formatAmount(data.adgYear15Id008) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.adgYear15Id008) }}
                                </span>
                                    </template>
                                </Column>

                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '10')"
                                    field="adgYear10Id007"
                                    header="R6 – Avg Div Growth 10yr" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R6 – Avg Div Growth 10yr</span>
                                        <span v-if="data.adgYear10Id007 >= 8">
                                  {{ this.formatAmount(data.adgYear10Id007) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.adgYear10Id007) }}
                                </span>
                                    </template>
                                </Column>

                                <Column v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '5')"
                                        field="adgYear5Id006"
                                        header="R6 – Avg Div Growth 5yr" :sortable="true"
                                        style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R6 – Avg Div Growth 5yr</span>
                                        <span v-if="data.adgYear5Id006 >= 8">
                                  {{ this.formatAmount(data.adgYear5Id006) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.adgYear5Id006) }}
                                </span>
                                    </template>
                                </Column>


                                <Column v-if="this.selectedFormat === 'Complete'" field="payoutRatioId107"
                                        header="R7 – Payout Ratio" :sortable="true"
                                        style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R7 – Payout Ratio</span>
                                        <span v-if="( (data.payoutRatioId107 <= 75) && (data.payoutRatioId107 > 0))">
                                  {{ this.formatAmount(data.payoutRatioId107) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.payoutRatioId107) }}
                                </span>
                                    </template>
                                </Column>

                                <Column v-if="this.selectedFormat === 'Complete'" field="longtermDebtEquityRatioId084"
                                        header="R8 - LT Debt/Equity" :sortable="true"
                                        style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R8 - LT Debt/Equity</span>
                                        <span
                                            v-if="( (data.longtermDebtEquityRatioId084 <= 70) && (data.longtermDebtEquityRatioId084 >= 0))">
                                  {{ this.formatAmount(data.longtermDebtEquityRatioId084) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.longtermDebtEquityRatioId084) }}
                                </span>
                                    </template>
                                </Column>

                                <Column v-if="this.selectedFormat === 'Complete'" field="afdPreviousId005"
                                        header="R9 - Fwd Dividend vs Prev Year" :sortable="true"
                                        style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R9 - Fwd Dividend vs Prev Year</span>
                                        <span v-if="data.afdPreviousId005 === -888888" :class="'highlight'">
                                  Dividend Eliminated
                                </span>
                                        <span v-else-if="data.afdPreviousId005 === -777777" :class="'highlight'">
                                  New Dividend
                                </span>
                                        <span v-else-if="data.afdPreviousId005 >= 0">
                                  {{ this.formatAmount(data.afdPreviousId005) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.afdPreviousId005) }}
                                </span>
                                    </template>
                                </Column>

                                <Column v-if="this.selectedFormat === 'Complete'" field="shareBuybackId122"
                                        header="R10 – Share Buyback?" :sortable="true"
                                        style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R10 – Share Buyback?</span>
                                        <span v-if="data.shareBuybackId122 === 'Y'">
                                  Yes
                                </span>
                                        <span v-else :class="'highlight'">
                                  No
                                </span>
                                    </template>
                                </Column>

                                <Column v-if="this.selectedFormat === 'Complete'" field="peRatioId104"
                                        header="R11a – P/E Ratio TTM" :sortable="true"
                                        style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R11a – P/E Ratio TTM</span>
                                        <span v-if="( (data.peRatioId104 <= 25) && (data.peRatioId104 > 0))">
                                  {{ this.formatAmount(data.peRatioId104) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.peRatioId104) }}
                                </span>
                                    </template>
                                </Column>


                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '20')"
                                    field="undervaluedVsOvervaluedStatusYear20Id135"
                                    header="R11b – Under/Over Valued Using 20yr Data" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R11b – Under/Over Valued Using 20yr Data</span>
                                        <span v-if="data.undervaluedVsOvervaluedStatusYear20Id135 === 'U'">
                                  Under-valued
                                </span>
                                        <span v-else :class="'highlight'">
                                  Over-valued
                                </span>
                                    </template>
                                </Column>

                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '15')"
                                    field="undervaluedVsOvervaluedStatusYear15Id134"
                                    header="R11b – Under/Over Valued Using 15yr Data" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R11b – Under/Over Valued Using 15yr Data</span>
                                        <span v-if="data.undervaluedVsOvervaluedStatusYear15Id134 === 'U'">
                                  Under-valued
                                </span>
                                        <span v-else :class="'highlight'">
                                  Over-valued
                                </span>
                                    </template>
                                </Column>

                                <Column
                                    v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '10')"
                                    field="undervaluedVsOvervaluedStatusYear10Id133"
                                    header="R11b – Under/Over Valued Using 10yr Data" :sortable="true"
                                    style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R11b – Under/Over Valued Using 10yr Data</span>
                                        <span v-if="data.undervaluedVsOvervaluedStatusYear10Id133 === 'U'">
                                  Under-valued
                                </span>
                                        <span v-else :class="'highlight'">
                                  Over-valued
                                </span>
                                    </template>
                                </Column>

                                <Column v-if="(this.selectedFormat === 'Complete') && (this.selectedTimePeriod === '5')"
                                        field="undervaluedVsOvervaluedStatusYear5Id132"
                                        header="R11b – Under/Over Valued Using 5yr Data" :sortable="true"
                                        style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R11b – Under/Over Valued Using 5yr Data</span>
                                        <span v-if="data.undervaluedVsOvervaluedStatusYear5Id132 === 'U'">
                                  Under-valued
                                </span>
                                        <span v-else :class="'highlight'">
                                  Over-valued
                                </span>
                                    </template>
                                </Column>


                                <Column v-if="this.selectedFormat === 'Complete'" field="pbRatioId102"
                                        header="R11c – P/B Ratio"
                                        :sortable="true" style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">R11c – P/B Ratio</span>
                                        <span v-if="( (data.pbRatioId102 <= 3) && (data.pbRatioId102 > 0))">
                                  {{ this.formatAmount(data.pbRatioId102) }}
                                </span>
                                        <span v-else :class="'highlight'">
                                  {{ this.formatAmount(data.pbRatioId102) }}
                                </span>
                                    </template>
                                </Column>

                                <Column v-if="this.selectedFormat === 'Complete'" field="yearsDividendIncreasesId047"
                                        header="Consecutive Yrs Div Increases" :sortable="true"
                                        style="max-width: 300px; min-width: 300px">
                                    <template #body="{data}">
                                        <span class="p-column-title">Consecutive Yrs Div Increases</span>
                                        <span>
                                  {{ data.yearsDividendIncreasesId047 }}
                                </span>
                                    </template>
                                </Column>

                            </DataTable>

                            <div class="field col-12">&nbsp;</div>
                        </div>
                    </div>


                    <div class="col-12">
                        <div class="card">
                            <h3>Graph for {{ this.specificStockData.companyNameId046 }}</h3>

                            <div class="col-12">
                                <div class="card p-fluid">
                                    <div class="grid">

                                        <div class="col-12 lg:col-2 p-3">
                                            <Dropdown v-model="selectedStockDataTimePeriod" :options="timePeriodsGraph"
                                                      optionLabel="name" optionValue="code"
                                                      placeholder="Select a Time Period"
                                                      @change="onStockDataTimePeriodChange"/>
                                        </div>

                                        <div class="col-12 lg:col-2 p-3">
                                            <Dropdown v-model="selectedStockDataStockHistoryOption"
                                                      :options="stockHistoryOptions"
                                                      optionLabel="name" optionValue="code"
                                                      placeholder="Select a Format"
                                                      @change="onStockDataStockHistoryOptionChange"/>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <Chart type="line" :data="lineData" :options="lineOptions"></Chart>
                            <div class="field col-12">&nbsp;</div>
                        </div>
                    </div>


                    <div class="col-12">
                        <div class="card">
                            <Button label="Back" class="mr-2 mb-2" @click="callOverviewWatchList"></Button>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 7" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add Watchlist Item</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callSetGoals" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Set Goals</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlist" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Watchlist</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlistAdd" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Add Watchlist Item</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlistDelete" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Remove Watchlist Item</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="field">
                        <label for="country">Exchange</label>
                        <Dropdown v-model="selectedWatchlistExchange" :options="exchanges"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <!--                        <label for="code">Company</label>-->
                        <!--                        <AutoComplete placeholder="Search by name" :dropdown="true" :multiple="false"-->
                        <!--                                      v-model="selectedWatchlistCode" :suggestions="filteredCodes"-->
                        <!--                                      @complete="searchCodes($event)" field="name"/>-->
                        <div class="field">
                            <label for="client">Company Name</label>
                            <AutoComplete
                                placeholder="Search by stock symbol or company name"
                                :dropdown="true"
                                :multiple="false"
                                v-model="selectedWatchlistCode"
                                :suggestions="filteredCodes"
                                @complete="searchCodes($event)"
                                field="label"
                                :class="{ 'p-invalid': submitted && !selectedWatchlistCode }"
                            />
                        </div>
                    </div>

                    <Button label="Save" :disabled="!canAddWatchlistItem" class="mr-2 mb-2"
                            @click="saveWatchlistItem"></Button>
                    <Button label="Back" class="mr-2 mb-2" @click="callOverviewWatchList"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 8" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Remove Watchlist Item</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callSetGoals" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Set Goals</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlist" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Watchlist</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlistAdd" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Add Watchlist Item</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callWatchlistDelete" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Remove Watchlist Item</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable
                        :value="watchList"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        responsiveLayout="scroll">

                        <template #empty>
                            No watchlist items found.
                        </template>

                        <template #loading>
                            Loading watchlist items. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1"
                                        :loading="submitted" @click="callDeleteWatchlistItem(data)"/>
                            </template>
                        </Column>

                        <Column field="exchange" header="Exchange" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Exchange</span>
                                {{ data.exchange }}
                            </template>
                        </Column>

                        <Column field="code" header="Stock Symbol" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Stock Symbol</span>
                                {{ data.code }}
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 9" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Watchlist Item for {{ this.existingWatchlistItem.code }}</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Item?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" @click="deleteWatchlistItem"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callOverviewWatchList"></Button>

                </div>
            </div>
        </div>

    </div>


    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuSiModuleMain from "@/components/menu/simodule/MenuSiModuleMain.vue";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import StockDataService from "@/service/StockDataService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import numeral from "numeral";
import ProgressSpinner from "primevue/progressspinner";
import StockHistoryService from "@/service/StockHistoryService";
import StockService from "@/service/StockService";
import WatchlistService from "@/service/WatchlistService";

export default {
    components: {
        SiFooter,
        MenuSiModuleMain,
        ProgressSpinner
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();
    },
    async mounted() {
        this.loading = true;

        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        try {
            const pingData = await UserService.getUserPing();
            console.log("[Applications][mounted] System is active.");
            console.log("[Applications][mounted] Data = ", pingData);
        } catch (e) {
            console.log("[Applications][mounted] System is NOT active.");
            console.log("[Applications][mounted] Error = ", e);

            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        if (this.userStore.user === undefined) {
            console.log("[Applications][mounted] User is NOT defined.");

            this.userStore.clearUser();
            // this.$router.push('login');
            this.$router.replace('/siLogin');
        } else {
            console.log("[Applications][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            try {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
                console.log("[Applications][mounted] Data = ", userData);

                if (this.profile.rights === 'C') {
                    this.activeTab = 1;
                } else {
                    this.activeTab = 3;
                }

                try {
                    const [userConfigData] = await Promise.all([
                        UserService.getUserConfig(this.userStore.user.id)
                    ]);

                    this.userConfiguration = userConfigData.data;
                    console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
                } catch (e) {
                    console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;

                }

                if (this.userConfiguration.enableSiUs === 'Y') {
                    var newEntry1 = {name: 'NYSE', code: 'NYSE'};
                    var newEntry2 = {name: 'NASDAQ', code: 'NASDAQ'};

                    var newCurrencyEntry1 = {name: 'USD', code: 'USD'};

                    this.exchanges.push(newEntry1);
                    this.exchanges.push(newEntry2);

                    this.currencyTypes.push(newCurrencyEntry1);
                }

                if (this.userConfiguration.enableSiCa === 'Y') {
                    var newEntry3 = {name: 'TSX', code: 'TO'};

                    var newCurrencyEntry2 = {name: 'CAD', code: 'CAD'};

                    this.exchanges.push(newEntry3);

                    this.currencyTypes.push(newCurrencyEntry2);
                }

                if (this.userConfiguration.enableSiUk === 'Y') {
                    var newEntry4 = {name: 'LSE', code: 'LSE'};

                    var newCurrencyEntry3 = {name: 'GBP', code: 'GBP'};

                    this.exchanges.push(newEntry4);

                    this.currencyTypes.push(newCurrencyEntry3);
                }

                if (this.userConfiguration.enableSiZa === 'Y') {
                    var newEntry5 = {name: 'JSE', code: 'JSE'};

                    var newCurrencyEntry4 = {name: 'ZAR', code: 'ZAR'};

                    this.exchanges.push(newEntry5);

                    this.currencyTypes.push(newCurrencyEntry4);
                }

                console.log("[Plan][mounted] this.exchanges = ", this.exchanges);

                if (this.exchanges.length > 0) {
                    this.selectedExchange = this.exchanges[0].code;
                }

                this.selectedColumns = this.columnConfig.filter(config =>
                    this.columnConfigCompact.some(compact => compact.field === config.field)
                );

                this.selectedFormat = "Compact";
                this.selectedStandardFilter = "topRanked";
                this.selectedTimePeriod = "20";

                console.log("[Plan][mounted] this.selectedExchange = ", this.selectedExchange);

                const promises = [
                    StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S'),
                    WatchlistService.getUserWatchlists(this.userStore.user.id)
                ];

                // Run the promises but do not await them.
                promises.forEach((promise, index) => {
                    promise.then(result => {
                        // Handle the result here, e.g., assign to a data property
                        if (index === 0) {
                            this.stockData = result.data;
                            this.originalStockData = result.data;
                        } else if (index === 1) {
                            this.watchList = result.data;
                        }
                    }).catch(e => {
                        // Handle the error here
                        console.error("Error in promise", index, e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    });
                });

                // const [stockDataInfo, watchlistInfo] = await Promise.all([
                //     StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S'),
                //     WatchlistService.getUserWatchlists(this.userStore.user.id)
                // ]);
                //
                // this.stockData = stockDataInfo.data;
                // this.originalStockData = stockDataInfo.data;
                // this.watchList = watchlistInfo.data;

                // console.log("[Plan][callWatchlist] this.originalStockData = ", this.originalStockData);
                //
                // const normalizedExchange = this.selectedExchange.trim().toUpperCase();
                //
                // console.log("[Plan][callWatchlist] normalizedExchange = ", normalizedExchange);
                //
                // // Filter stock data based on watchlist and exchange
                // this.stockData = this.stockData.filter(stock =>
                //     // Match stock codes with watchlist items and their exchange value
                //     this.watchList.some(item =>
                //         stock.codeId129 === item.code &&
                //         stock.exchangeId073?.trim().toUpperCase() === item.exchange?.trim().toUpperCase() &&
                //         item.exchange?.trim().toUpperCase() === normalizedExchange
                //     )
                // );

                this.loading = false;

            } catch (e) {
                console.log("[Applications][mounted] No user data found.");
                console.log("[Applications][mounted] Error = ", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

            this.loading = false;
        }
    },
    data() {

        return {
            profile: {},
            userConfiguration: {},
            activeTab: 3,
            loading: false,
            submitted: false,
            exchanges: [],
            selectedExchange: "NYSE",
            selectedFormat: "Compact",
            selectedTimePeriod: "20",
            filters: null,
            stockData: [],
            stockHistory: [],
            specificStockData: {},
            specificStockDataArray: [],
            maxDividendYield: 0,
            lineData: [],
            lineOptions: [],
            selectedStockDataTimePeriod: "20",
            selectedStockDataStockHistoryOption: "DPS",
            searchCriteria: '',
            selectedWatchlistExchange: "NYSE",
            selectedWatchlistCode: '',
            filteredCodes: [],
            confirmationResponse: 'N',
            existingWatchlistItem: {},
            topRankedNyseCriteria: 10,
            topRankedLseCriteria: 6,
            topRankedJseCriteria: 6,
            runnersUpNyseCriteria: 9,
            runnersUpLseCriteria: 5,
            runnersUpJseCriteria: 5,
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            timePeriods: [
                {name: '20 Year', code: '20'},
                {name: '15 Year', code: '15'},
                {name: '10 Year', code: '10'},
                {name: '5 Year', code: '5'}
            ],
            timePeriodsGraph: [
                {name: '20 Year', code: '20'},
                {name: '15 Year', code: '15'},
                {name: '10 Year', code: '10'},
                {name: '5 Year', code: '5'},
                {name: 'Maximum', code: 'Maximum'},
            ],
            stockHistoryOptions: [
                {name: 'Dividends Per Share', code: 'DPS'},
                {name: 'Low Price', code: 'LSP'},
                {name: 'High Price', code: 'HSP'},
                {name: 'Average Price', code: 'ASP'},
                {name: 'EPS', code: 'EPS'}
            ],
            // currencyTypes: [
            //     {name: 'USD', code: 'USD'},
            //     {name: 'CAD', code: 'CAD'},
            //     {name: 'GBP', code: 'GBP'},
            //     {name: 'ZAR', code: 'ZAR'}
            // ],
            currencyTypes: [],
            formats: [
                {name: 'Minimal View', code: 'Compact'},
                {name: 'Extended View', code: 'Complete'}
            ],
            years: [
                {name: 2025, code: 2025},
                {name: 2026, code: 2026},
                {name: 2027, code: 2027},
                {name: 2028, code: 2028},
                {name: 2029, code: 2029},
                {name: 2030, code: 2030},
                {name: 2031, code: 2031},
                {name: 2032, code: 2032},
                {name: 2033, code: 2033},
                {name: 2034, code: 2034},
                {name: 2035, code: 2035},
                {name: 2036, code: 2036},
                {name: 2037, code: 2037},
                {name: 2038, code: 2038},
                {name: 2039, code: 2039},
                {name: 2040, code: 2040},
                {name: 2041, code: 2041},
                {name: 2042, code: 2042},
                {name: 2043, code: 2043},
                {name: 2044, code: 2044},
                {name: 2045, code: 2045},
                {name: 2046, code: 2046},
                {name: 2047, code: 2047},
                {name: 2048, code: 2048},
                {name: 2049, code: 2049},
                {name: 2050, code: 2050}
            ],
            watchList: [],
            // watchList: [
            //     {exchange: 'JSE', code: 'TRU'},
            //     {exchange: 'JSE', code: 'CLH'},
            //     {exchange: 'JSE', code: 'AME'}
            // ],
            selectedColumns: [],
            columnConfig: [
                {
                    field: 'codeId129',
                    header: 'Stock Symbol',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    frozen: true,
                    body: 'link',
                    condition: () => this.selectedColumns.some(col => col.field === 'codeId129'),
                },
                {
                    field: 'companyNameId046',
                    header: 'Name',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyNameId046'),
                },
                {
                    field: 'sharePriceId123',
                    header: 'Share Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () => this.selectedColumns.some(col => col.field === 'sharePriceId123'),
                },
                {
                    field: 'currentDividendYieldId050',
                    header: 'Current Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'dividend',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentDividendYieldId050'),
                },
                {
                    field: 'siCriteriaYear20Id128',
                    header: 'SI Criteria out of 10 (20yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear20Id128'),
                },
                {
                    field: 'siCriteriaYear15Id127',
                    header: 'SI Criteria out of 10 (15yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear15Id127'),
                },
                {
                    field: 'siCriteriaYear10Id126',
                    header: 'SI Criteria out of 10 (10yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear10Id126'),
                },
                {
                    field: 'siCriteriaYear5Id125',
                    header: 'SI Criteria out of 10 (5yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear5Id125'),
                },
                {
                    field: 'averageEpsGrowthYear20Id018',
                    header: 'R5a – Avg EPS Growth 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear20Id018'),
                },
                {
                    field: 'averageEpsGrowthYear15Id017',
                    header: 'R5a – Avg EPS Growth 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear15Id017'),
                },
                {
                    field: 'averageEpsGrowthYear10Id016',
                    header: 'R5a – Avg EPS Growth 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear10Id016'),
                },
                {
                    field: 'averageEpsGrowthYear5Id015',
                    header: 'R5a – Avg EPS Growth 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear5Id015'),
                },
                {
                    field: 'epsIncreasesYear20Id097',
                    header: 'R5b – EPS Increases in 20yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear20Id097'),
                },
                {
                    field: 'epsIncreasesYear15Id096',
                    header: 'R5b – EPS Increases in 15yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear15Id096'),
                },
                {
                    field: 'epsIncreasesYear10Id095',
                    header: 'R5b – EPS Increases in 10yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear10Id095'),
                },
                {
                    field: 'epsIncreasesYear5Id094',
                    header: 'R5b – EPS Increases in 5yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear5Id094'),
                },
                {
                    field: 'adgYear20Id009',
                    header: 'R6 – Avg Div Growth 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'adgYear20Id009'),
                },
                {
                    field: 'adgYear15Id008',
                    header: 'R6 – Avg Div Growth 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'adgYear15Id008'),
                },
                {
                    field: 'adgYear10Id007',
                    header: 'R6 – Avg Div Growth 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'adgYear10Id007'),
                },
                {
                    field: 'adgYear5Id006',
                    header: 'R6 – Avg Div Growth 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'adgYear5Id006'),
                },
                {
                    field: 'payoutRatioId107',
                    header: 'R7 – Payout Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'payoutRatioId107'),
                },
                {
                    field: 'longtermDebtEquityRatioId084',
                    header: 'R8 - LT Debt/Equity',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'longtermDebtEquityRatioId084'),
                },
                {
                    field: 'afdPreviousId005',
                    header: 'R9 - Fwd Dividend vs Prev Year',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'afdPreviousId005'),
                },
                {
                    field: 'shareBuybackId122',
                    header: 'R10 – Share Buyback?',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-buyback',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'shareBuybackId122'),
                },
                {
                    field: 'peRatioId104',
                    header: 'R11a – P/E Ratio TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'peRatioId104'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear20Id135',
                    header: 'R11b – Under/Over Valued Using 20yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear20Id135'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear15Id134',
                    header: 'R11b – Under/Over Valued Using 15yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear15Id134'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear10Id133',
                    header: 'R11b – Under/Over Valued Using 10yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear10Id133'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear5Id132',
                    header: 'R11b – Under/Over Valued Using 5yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear5Id132'),
                },
                {
                    field: 'pbRatioId102',
                    header: 'R11c – P/B Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pbRatioId102'),
                },
                {
                    field: 'yearsDividendIncreasesId047',
                    header: 'Consecutive Yrs Div Increases',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'yearsDividendIncreasesId047'),
                },
                {
                    field: 'hspWeek52Id001',
                    header: '52wk High',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'hspWeek52Id001'),
                },
                {
                    field: 'lspWeek52Id002',
                    header: '52wk Low',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'lspWeek52Id002'),
                },
                {
                    field: 'altmanZscoreId003',
                    header: 'Altman Z-Score',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'altmanZscoreId003'),
                },
                {
                    field: 'afdId004',
                    header: 'Annual Fwd Dividend',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'afdId004'),
                },
                {
                    field: 'adyYear5Id010',
                    header: 'Avg Div Yld 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'adyYear5Id010'),
                },
                {
                    field: 'adyYear10Id011',
                    header: 'Avg Div Yld 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'adyYear10Id011'),
                },
                {
                    field: 'adyYear15Id012',
                    header: 'Avg Div Yld 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'adyYear15Id012'),
                },
                {
                    field: 'adyYear20Id013',
                    header: 'Avg Div Yld 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'adyYear20Id013'),
                },

                {
                    field: 'averageEpsYear3Id014',
                    header: 'Avg 3yr EPS',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageEpsYear3Id014'),
                },
                {
                    field: 'averageHdyYear5Id019',
                    header: 'Avg High Div Yld 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHdyYear5Id019'),
                },
                {
                    field: 'averageHdyYear10Id020',
                    header: 'Avg High Div Yld 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHdyYear10Id020'),
                },
                {
                    field: 'averageHdyYear15Id021',
                    header: 'Avg High Div Yld 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHdyYear15Id021'),
                },
                {
                    field: 'averageHdyYear20Id022',
                    header: 'Avg High Div Yld 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHdyYear20Id022'),
                },
                {
                    field: 'averageHighPeRatioYear5Id023',
                    header: 'Avg High P/E 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHighPeRatioYear5Id023'),
                },
                {
                    field: 'averageHighPeRatioYear10Id024',
                    header: 'Avg High P/E 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHighPeRatioYear10Id024'),
                },
                {
                    field: 'averageHighPeRatioYear15Id025',
                    header: 'Avg High P/E 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHighPeRatioYear15Id025'),
                },
                {
                    field: 'averageHighPeRatioYear20Id026',
                    header: 'Avg High P/E 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageHighPeRatioYear20Id026'),
                },
                {
                    field: 'averageLdyYear5Id027',
                    header: 'Avg Low Div Yld 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLdyYear5Id027'),
                },
                {
                    field: 'averageLdyYear10Id028',
                    header: 'Avg Low Div Yld 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLdyYear10Id028'),
                },
                {
                    field: 'averageLdyYear15Id029',
                    header: 'Avg Low Div Yld 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLdyYear15Id029'),
                },
                {
                    field: 'averageLdyYear20Id030',
                    header: 'Avg Low Div Yld 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLdyYear20Id030'),
                },
                {
                    field: 'averageLowPeRatioYear5Id031',
                    header: 'Avg Low P/E 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLowPeRatioYear5Id031'),
                },
                {
                    field: 'averageLowPeRatioYear10Id032',
                    header: 'Avg Low P/E 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLowPeRatioYear10Id032'),
                },
                {
                    field: 'averageLowPeRatioYear15Id033',
                    header: 'Avg Low P/E 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLowPeRatioYear15Id033'),
                },
                {
                    field: 'averageLowPeRatioYear20Id034',
                    header: 'Avg Low P/E 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averageLowPeRatioYear20Id034'),
                },
                {
                    field: 'averagePeRatioYear5Id035',
                    header: 'Avg P/E 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averagePeRatioYear5Id035'),
                },
                {
                    field: 'averagePeRatioYear10Id036',
                    header: 'Avg P/E 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averagePeRatioYear10Id036'),
                },
                {
                    field: 'averagePeRatioYear15Id037',
                    header: 'Avg P/E 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averagePeRatioYear15Id037'),
                },
                {
                    field: 'averagePeRatioYear20Id038',
                    header: 'Avg P/E 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'averagePeRatioYear20Id038'),
                },
                {
                    field: 'bookValuePerShareId039',
                    header: 'Bk Value/Share',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'bookValuePerShareId039'),
                },
                {
                    field: 'cashFlowPerShareId040',
                    header: 'Cashflow/Share',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'cashFlowPerShareId040'),
                },
                {
                    field: 'companyAddressCityId041',
                    header: 'City',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyAddressCityId041'),
                },
                {
                    field: 'companyAddressCountryId042',
                    header: 'Country',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyAddressCountryId042'),
                },
                {
                    field: 'companyAddressStateId043',
                    header: 'State/Prov',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyAddressStateId043'),
                },
                {
                    field: 'companyAddressId044',
                    header: 'Address',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyAddressId044'),
                },
                {
                    field: 'companyDescriptionId045',
                    header: 'Description',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyDescriptionId045'),
                },
                {
                    field: 'yearsEpsIncreasesId048',
                    header: 'Consecutive Yrs EPS Increases',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'yearsEpsIncreasesId048'),
                },
                {
                    field: 'currentAssetsId049',
                    header: 'Current Assets',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentAssetsId049'),
                },
                {
                    field: 'currentLiabilitiesId051',
                    header: 'Current Debt',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentLiabilitiesId051'),
                },
                {
                    field: 'currentRatioId052',
                    header: 'Current Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentRatioId052'),
                },
                {
                    field: 'diffDyCurrentVsAverageYear5Id053',
                    header: 'Diff Between Current Div Yld & Avg Div Yld 5yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffDyCurrentVsAverageYear5Id053'),
                },
                {
                    field: 'diffDyCurrentVsAverageYear10Id054',
                    header: 'Diff Between Current Div Yld & Avg Div Yld 10yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffDyCurrentVsAverageYear10Id054'),
                },
                {
                    field: 'diffDyCurrentVsAverageYear15Id055',
                    header: 'Diff Between Current Div Yld & Avg Div Yld 15yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffDyCurrentVsAverageYear15Id055'),
                },
                {
                    field: 'diffDyCurrentVsAverageYear20Id056',
                    header: 'Diff Between Current Div Yld & Avg Div Yld 20yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffDyCurrentVsAverageYear20Id056'),
                },
                {
                    field: 'diffPeCurrentVsAverageYear5Id057',
                    header: 'Diff Between Current P/E & Avg P/E 5yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffPeCurrentVsAverageYear5Id057'),
                },
                {
                    field: 'diffPeCurrentVsAverageYear10Id058',
                    header: 'Diff Between Current P/E & Avg P/E 10yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffPeCurrentVsAverageYear10Id058'),
                },
                {
                    field: 'diffPeCurrentVsAverageYear15Id059',
                    header: 'Diff Between Current P/E & Avg P/E 15yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffPeCurrentVsAverageYear15Id059'),
                },
                {
                    field: 'diffPeCurrentVsAverageYear20Id060',
                    header: 'Diff Between Current P/E & Avg P/E 20yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffPeCurrentVsAverageYear20Id060'),
                },

                {
                    field: 'dcfId061',
                    header: 'DCF',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dcfId061'),
                },
                {
                    field: 'dividendCurrencyId062',
                    header: 'Div Currency',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dividendCurrencyId062'),
                },
                {
                    field: 'dividendFrequencyId063',
                    header: 'Div Frequency',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dividendFrequencyId063'),
                },

                {
                    field: 'dgPlusDyYear5Id064',
                    header: 'Div Gr (5yr) + Curr Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dgPlusDyYear5Id064'),
                },
                {
                    field: 'dgPlusDyYear10Id065',
                    header: 'Div Gr (10yr) + Curr Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dgPlusDyYear10Id065'),
                },
                {
                    field: 'dgPlusDyYear15Id066',
                    header: 'Div Gr (15yr) + Curr Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dgPlusDyYear15Id066'),
                },
                {
                    field: 'dgPlusDyYear20Id067',
                    header: 'Div Gr (20yr) + Curr Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dgPlusDyYear20Id067'),
                },
                {
                    field: 'dividendPaymentDateId068',
                    header: 'Div Payment Date',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dividendPaymentDateId068'),
                },
                {
                    field: 'dividendRecordDateId069',
                    header: 'Div Record Date',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dividendRecordDateId069'),
                },
                {
                    field: 'dividendPaidId070',
                    header: 'Divs Paid Since',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'dividendPaidId070'),
                },
                {
                    field: 'epsTtmId071',
                    header: 'EPS (TTM)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'epsTtmId071'),
                },
                {
                    field: 'esgScoreId072',
                    header: 'ESG Score',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'esgScoreId072'),
                },
                {
                    field: 'exchangeId073',
                    header: 'Exchange',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'exchangeId073'),
                },
                {
                    field: 'exDividendDateId074',
                    header: 'Ex-Div Date',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'exDividendDateId074'),
                },
                {
                    field: 'fiscalYearendDateId075',
                    header: 'Fiscal Yr End',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'fiscalYearendDateId075'),
                },
                {
                    field: 'grahamPriceId076',
                    header: 'Graham Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'grahamPriceId076'),
                },
                {
                    field: 'hspYear5Id077',
                    header: 'High Price Using 5yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'hspYear5Id077'),
                },
                {
                    field: 'hspYear10Id078',
                    header: 'High Price Using 10yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'hspYear10Id078'),
                },
                {
                    field: 'hspYear15Id079',
                    header: 'High Price Using 15yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'hspYear15Id079'),
                },
                {
                    field: 'hspYear20Id080',
                    header: 'High Price Using 20yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'hspYear20Id080'),
                },
                {
                    field: 'industryId081',
                    header: 'Industry',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'industryId081'),
                },
                {
                    field: 'longtermDebtId082',
                    header: 'LT Debt',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'longtermDebtId082'),
                },
                {
                    field: 'longtermDebtVsTotalCapitalId083',
                    header: 'LT Debt/Total Capital',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'longtermDebtVsTotalCapitalId083'),
                },
                {
                    field: 'lspYear5Id085',
                    header: 'Low Price Using 5yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'lspYear5Id085'),
                },
                {
                    field: 'lspYear10Id086',
                    header: 'Low Price Using 10yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'lspYear10Id086'),
                },
                {
                    field: 'lspYear15Id087',
                    header: 'Low Price Using 15yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'lspYear15Id087'),
                },
                {
                    field: 'lspYear20Id088',
                    header: 'Low Price Using 20yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'lspYear20Id088'),
                },
                {
                    field: 'marketId089',
                    header: 'Market/Country',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'marketId089'),
                },
                {
                    field: 'marketCapitalisationId090',
                    header: 'Market Cap',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'marketCapitalisationId090'),
                },
                {
                    field: 'netIncomeId091',
                    header: 'Net Income',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'netIncomeId091'),
                },
                {
                    field: 'netIncomePerShareId092',
                    header: 'Net Income/Share TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'netIncomePerShareId092'),
                },

                {
                    field: 'employeesId093',
                    header: 'Employees',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'employeesId093'),
                },
                {
                    field: 'outstandingSharesCurrentYearId098',
                    header: 'Share Outstanding',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'outstandingSharesCurrentYearId098'),
                },
                {
                    field: 'outstandingSharesPreviousYearId099',
                    header: 'Share Outstanding (previous Yr)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'outstandingSharesPreviousYearId099'),
                },
                {
                    field: 'operatingCashflowId100',
                    header: 'Operating Cashflow',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'operatingCashflowId100'),
                },
                {
                    field: 'operatingCashflowRatioId101',
                    header: 'Operating Cashflow Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'operatingCashflowRatioId101'),
                },
                {
                    field: 'pcfRatioId103',
                    header: 'P/CF Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pcfRatioId103'),
                },
                {
                    field: 'pfcfRatioId105',
                    header: 'P/FCF Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pfcfRatioId105'),
                },
                {
                    field: 'psRatioId106',
                    header: 'P/S Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'psRatioId106'),
                },
                {
                    field: 'pegRatioYear5Id108',
                    header: 'PEG Ratio Using Avg EPS Growth 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pegRatioYear5Id108'),
                },
                {
                    field: 'pegRatioYear10Id109',
                    header: 'PEG Ratio Using Avg EPS Growth 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pegRatioYear10Id109'),
                },
                {
                    field: 'pegRatioYear15Id110',
                    header: 'PEG Ratio Using Avg EPS Growth 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pegRatioYear15Id110'),
                },
                {
                    field: 'pegRatioYear20Id111',
                    header: 'PEG Ratio Using Avg EPS Growth 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pegRatioYear20Id111'),
                },
                {
                    field: 'diffGrahamPriceSharePriceId112',
                    header: '% diff Graham Price vs Share Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'diffGrahamPriceSharePriceId112'),
                },
                {
                    field: 'sharesOwnedInstitutionsId113',
                    header: '% Owned by Institutions',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'sharesOwnedInstitutionsId113'),
                },
                {
                    field: 'piotroskiFscoreId114',
                    header: 'Piotroski F-Score',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'piotroskiFscoreId114'),
                },
                {
                    field: 'profitMarginId115',
                    header: 'Total Operating Profit Margin',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'profitMarginId115'),
                },
                {
                    field: 'quickRatioId116',
                    header: 'Quick Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'quickRatioId116'),
                },
                {
                    field: 'recentDividendPaymentId117',
                    header: 'Recent Div Payment',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'recentDividendPaymentId117'),
                },
                {
                    field: 'roaTtmId118',
                    header: 'ROA TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'roaTtmId118'),
                },
                {
                    field: 'rocTtmId119',
                    header: 'ROC TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'rocTtmId119'),
                },
                {
                    field: 'roeTtmId120',
                    header: 'ROE TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'roeTtmId120'),
                },
                {
                    field: 'sectorId121',
                    header: 'Sector',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'sectorId121'),
                },
                {
                    field: 'sharePriceDateId124',
                    header: 'Share Date & Time',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'sharePriceDateId124'),
                },
                {
                    field: 'totalDebtVsEquityRatioId130',
                    header: 'Total Debt/Equity Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'totalDebtVsEquityRatioId130'),
                },
                {
                    field: 'totalStockholderEquityId131',
                    header: 'Total Stockholder Equity',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'totalStockholderEquityId131'),
                },
                {
                    field: 'websiteId136',
                    header: 'Website',
                    style: 'max-width: 400px; min-width: 400px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'websiteId136'),
                },
            ],
            columnConfigCompact: [
                {
                    field: 'codeId129',
                    header: 'Stock Symbol',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    frozen: true,
                    body: 'link',
                    condition: () => this.selectedColumns.some(col => col.field === 'codeId129'),
                },
                {
                    field: 'companyNameId046',
                    header: 'Name',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyNameId046'),
                },
                {
                    field: 'sharePriceId123',
                    header: 'Share Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () => this.selectedColumns.some(col => col.field === 'sharePriceId123'),
                },
                {
                    field: 'currentDividendYieldId050',
                    header: 'Current Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'dividend',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentDividendYieldId050'),
                },
                {
                    field: 'siCriteriaYear20Id128',
                    header: 'SI Criteria out of 10 (20yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear20Id128'),
                },
                {
                    field: 'siCriteriaYear20Id128',
                    header: 'SI Criteria out of 10 (20yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear20Id128'),
                },
                {
                    field: 'siCriteriaYear15Id127',
                    header: 'SI Criteria out of 10 (15yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear15Id127'),
                },
                {
                    field: 'siCriteriaYear10Id126',
                    header: 'SI Criteria out of 10 (10yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear10Id126'),
                },
                {
                    field: 'siCriteriaYear5Id125',
                    header: 'SI Criteria out of 10 (5yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear5Id125'),
                },
            ],
            columnConfigCompactLite: [
                {
                    field: 'codeId129',
                    header: 'Stock Symbol',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    frozen: true,
                    body: 'link',
                    condition: () => this.selectedColumns.some(col => col.field === 'codeId129'),
                },
                {
                    field: 'companyNameId046',
                    header: 'Name',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyNameId046'),
                },
                {
                    field: 'sharePriceId123',
                    header: 'Share Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () => this.selectedColumns.some(col => col.field === 'sharePriceId123'),
                },
                {
                    field: 'currentDividendYieldId050',
                    header: 'Current Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'dividend',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentDividendYieldId050'),
                }
            ],
            columnConfigComplete: [
                {
                    field: 'codeId129',
                    header: 'Stock Symbol',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    frozen: true,
                    body: 'link',
                    condition: () => this.selectedColumns.some(col => col.field === 'codeId129'),
                },
                {
                    field: 'companyNameId046',
                    header: 'Name',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'companyNameId046'),
                },
                {
                    field: 'sharePriceId123',
                    header: 'Share Price',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () => this.selectedColumns.some(col => col.field === 'sharePriceId123'),
                },
                {
                    field: 'currentDividendYieldId050',
                    header: 'Current Div Yld',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'dividend',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'currentDividendYieldId050'),
                },
                {
                    field: 'siCriteriaYear20Id128',
                    header: 'SI Criteria out of 10 (20yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear20Id128'),
                },
                {
                    field: 'siCriteriaYear15Id127',
                    header: 'SI Criteria out of 10 (15yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear15Id127'),
                },
                {
                    field: 'siCriteriaYear10Id126',
                    header: 'SI Criteria out of 10 (10yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear10Id126'),
                },
                {
                    field: 'siCriteriaYear5Id125',
                    header: 'SI Criteria out of 10 (5yr Data)',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'siCriteriaYear5Id125'),
                },
                {
                    field: 'averageEpsGrowthYear20Id018',
                    header: 'R5a – Avg EPS Growth 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear20Id018'),
                },
                {
                    field: 'averageEpsGrowthYear15Id017',
                    header: 'R5a – Avg EPS Growth 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear15Id017'),
                },
                {
                    field: 'averageEpsGrowthYear10Id016',
                    header: 'R5a – Avg EPS Growth 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear10Id016'),
                },
                {
                    field: 'averageEpsGrowthYear5Id015',
                    header: 'R5a – Avg EPS Growth 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'averageEpsGrowthYear5Id015'),
                },
                {
                    field: 'epsIncreasesYear20Id097',
                    header: 'R5b – EPS Increases in 20yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear20Id097'),
                },
                {
                    field: 'epsIncreasesYear15Id096',
                    header: 'R5b – EPS Increases in 15yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear15Id096'),
                },
                {
                    field: 'epsIncreasesYear10Id095',
                    header: 'R5b – EPS Increases in 10yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear10Id095'),
                },
                {
                    field: 'epsIncreasesYear5Id094',
                    header: 'R5b – EPS Increases in 5yrs',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'epsIncreasesYear5Id094'),
                },
                {
                    field: 'adgYear20Id009',
                    header: 'R6 – Avg Div Growth 20yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'adgYear20Id009'),
                },
                {
                    field: 'adgYear15Id008',
                    header: 'R6 – Avg Div Growth 15yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'adgYear15Id008'),
                },
                {
                    field: 'adgYear10Id007',
                    header: 'R6 – Avg Div Growth 10yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'adgYear10Id007'),
                },
                {
                    field: 'adgYear5Id006',
                    header: 'R6 – Avg Div Growth 5yr',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'adgYear5Id006'),
                },
                {
                    field: 'payoutRatioId107',
                    header: 'R7 – Payout Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'payoutRatioId107'),
                },
                {
                    field: 'longtermDebtEquityRatioId084',
                    header: 'R8 - LT Debt/Equity',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'longtermDebtEquityRatioId084'),
                },
                {
                    field: 'afdPreviousId005',
                    header: 'R9 - Fwd Dividend vs Prev Year',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'afdPreviousId005'),
                },
                {
                    field: 'shareBuybackId122',
                    header: 'R10 – Share Buyback?',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-buyback',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'shareBuybackId122'),
                },
                {
                    field: 'peRatioId104',
                    header: 'R11a – P/E Ratio TTM',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'peRatioId104'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear20Id135',
                    header: 'R11b – Under/Over Valued Using 20yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '20' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear20Id135'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear15Id134',
                    header: 'R11b – Under/Over Valued Using 15yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '15' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear15Id134'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear10Id133',
                    header: 'R11b – Under/Over Valued Using 10yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '10' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear10Id133'),
                },
                {
                    field: 'undervaluedVsOvervaluedStatusYear5Id132',
                    header: 'R11b – Under/Over Valued Using 5yr Data',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-overvalue',
                    condition: () =>
                        this.selectedTimePeriod === '5' &&
                        this.selectedColumns.some(col => col.field === 'undervaluedVsOvervaluedStatusYear5Id132'),
                },
                {
                    field: 'pbRatioId102',
                    header: 'R11c – P/B Ratio',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    body: 'format-number',
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'pbRatioId102'),
                },
                {
                    field: 'yearsDividendIncreasesId047',
                    header: 'Consecutive Yrs Div Increases',
                    style: 'max-width: 200px; min-width: 200px',
                    sortable: true,
                    condition: () =>
                        this.selectedColumns.some(col => col.field === 'yearsDividendIncreasesId047'),
                }
            ]
        }
    },
    computed: {
        filteredColumns() {
            console.log("[Overview][computed] this.columnConfig.filter(column => column.condition()) = ",
                this.columnConfig.filter(column => column.condition()));
            return this.columnConfig.filter(column => column.condition());
        },
        canAddWatchlistItem() {
            return (
                this.selectedWatchlistExchange &&
                this.selectedWatchlistCode
            );
        },
    },
    methods: {
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        callSetGoals() {
            this.activeTab = 3;
        },
        callOverviewWatchList() {
            this.activeTab = 4;
        },
        callOverview() {
            this.$router.push("siOverview");
        },
        async onTimePeriodChange() {
            this.loading = true;

            try {
                console.log("[Overview][onTimePeriodChange] this.selectedTimePeriod = ", this.selectedTimePeriod);
                // console.log("[Overview][onTimePeriodChange] this.stock.undervaluedVsOvervaluedStatusYear5Id132 = ",
                //     this.stock.undervaluedVsOvervaluedStatusYear5Id132);

                this.selectedFormat = "Compact";

                if (this.selectedExchange === "JSE") {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedJseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedJseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedJseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedJseCriteria);
                    }

                } else if (this.selectedExchange === "LSE") {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedLseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedLseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedLseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
                    }

                } else {
                    if (this.selectedTimePeriod === "5") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear5Id125 === this.topRankedNyseCriteria);
                    } else if (this.selectedTimePeriod === "10") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear10Id126 === this.topRankedNyseCriteria);
                    } else if (this.selectedTimePeriod === "15") {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear15Id127 === this.topRankedNyseCriteria);
                    } else {
                        this.stockData = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
                    }

                }

                this.stockData = this.stockData
                    .sort((a, b) => b.yearsDividendIncreasesId047 - a.yearsDividendIncreasesId047);

                if (this.selectedFormat === "Compact") {
                    if (this.selectedTimePeriod === "5") {
                        this.selectedColumns = this.columnConfigCompact;

                    } else if (this.selectedTimePeriod === "10") {

                        this.selectedColumns = this.columnConfigCompact;

                    } else if (this.selectedTimePeriod === "15") {

                        this.selectedColumns = this.columnConfigCompact;

                    } else {
                        this.selectedColumns = this.columnConfigCompact;

                    }
                } else {

                    if (this.selectedTimePeriod === "5") {
                        this.selectedColumns = this.columnConfigComplete;

                    } else if (this.selectedTimePeriod === "10") {
                        this.selectedColumns = this.columnConfigComplete;

                    } else if (this.selectedTimePeriod === "15") {
                        this.selectedColumns = this.columnConfigComplete;

                    } else {
                        this.selectedColumns = this.columnConfigComplete;

                    }

                }

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }

        },
        async onFormatChange() {
            console.log("[Plan][onFilterChange] this.selectedFormat = ", this.selectedFormat);

            if (this.selectedFormat === "Compact") {
                this.selectedColumns = this.columnConfig.filter(config =>
                    this.columnConfigCompact.some(compact => compact.field === config.field)
                );

            } else {

                this.selectedColumns = this.columnConfig.filter(config =>
                    this.columnConfigComplete.some(compact => compact.field === config.field)
                );

            }
        },
        handleDTClick() {
            this.activeTab = 5;
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'codeId129': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
                },
                'companyNameId046': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
                }
            }
        },
        clearFilter() {
            this.initFilters();
        },
        restoreToOriginal() {
            window.location.reload();
        },
        // searchCodes(event) {
        //     console.log("[Plan][searchCodes] event.query = ", event.query);
        //     console.log("[Plan][searchCodes] this.selectedWatchlistExchange = ", this.selectedWatchlistExchange);
        //
        //     StockService.searchStocksForExchangeByName(this.selectedWatchlistExchange, event.query.toLowerCase())
        //         .then(data => {
        //             console.log("[Plan][searchCodes] Getting codes for exchange = ", this.selectedWatchlistExchange);
        //             this.filteredCodes = data.data;
        //             console.log("[Plan][searchCodes] Got codes = ", data.data);
        //         })
        //         .catch(e => {
        //             console.log("[Plan][searchCodes] Could not get codes for exchange = ", this.selectedWatchlistExchange);
        //             console.log("[Plan][searchCodes] Error = ", e);
        //         });
        //
        // },
        searchCodes(event) {
            console.log("[Plan][searchCodes] event.query = ", event.query);
            console.log("[Plan][searchCodes] this.selectedWatchlistExchange = ", this.selectedWatchlistExchange);
            console.log("[Plan][searchCodes] this.selectedWatchlistCode = ", this.selectedWatchlistCode);

            StockService.searchStocksForExchangeByName(this.selectedWatchlistExchange, event.query.toLowerCase())
                .then(data => {
                    const searchResults = data.data;

                    // Get a list of codes that are already in the watchlist for the selected exchange
                    const watchlistCodes = this.watchList
                        .filter(item => item.exchange === this.selectedWatchlistExchange)
                        .map(item => item.code);

                    // Filter the search results to exclude any codes found in the watchlist
                    const filteredResults = searchResults.filter(stock => {
                        // Check if the stock's code is NOT in the watchlistCodes array
                        return !watchlistCodes.includes(stock.code);
                    });

                    this.filteredCodes = filteredResults.map(stock => ({
                        label: `${stock.name} (${stock.code})`,
                        value: stock.code
                    }));

                    console.log("[Plan][searchCodes] Got watchlist codes = ", this.filteredCodes);

                    // this.filteredCodes = data.data.map(stock => ({
                    //     label: `${stock.name} (${stock.code})`,
                    //     value: stock.code // or the entire stock object, depending on your needs
                    // }));
                    //
                    // console.log("[Plan][searchCodes] Got client data = ", data.data);
                })
                .catch(e => {
                    console.log("[Plan][searchCodes] Error = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                });
        },
        async onExchangeChange() {
            this.loading = true;

            try {
                this.selectedFormat = "Compact";
                this.selectedStandardFilter = "topRanked";
                this.selectedTimePeriod = "20";

                const [stockDataInfo] = await Promise.all([
                    StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S')
                ]);

                this.stockData = stockDataInfo.data;
                this.originalStockData = stockDataInfo.data;

                this.getDividendTrap();

                console.log("[Plan][onExchangeChange] this.selectedExchange = ", this.selectedExchange);
                console.log("[Plan][onExchangeChange] this.stockData = ", this.stockData);

                // Normalize exchange for consistent comparison
                const normalizedExchange = this.selectedExchange.trim().toUpperCase();

                console.log("[Plan][onExchangeChange] normalizedExchange = ", normalizedExchange);

                // Filter stock data based on watchlist and exchange
                this.stockData = this.stockData.filter(stock =>
                    // Match stock codes with watchlist items and their exchange value
                    this.watchList.some(item =>
                        stock.codeId129 === item.code &&
                        stock.exchangeId073?.trim().toUpperCase() === item.exchange?.trim().toUpperCase() &&
                        item.exchange?.trim().toUpperCase() === normalizedExchange
                    )
                );

                // let criteriaString = "";
                //
                // this.watchList.forEach((item, index, array) => {
                //     if (index === array.length - 1) {
                //         console.log("This is the last element.");
                //         criteriaString = criteriaString + "stock.codeId129 === '" + item.code + "' ";
                //     } else {
                //         criteriaString = criteriaString + "stock.codeId129 === '" + item.code + "' || ";
                //     }
                // });
                //
                // try {
                //     console.log("[Debug] criteriaString:", criteriaString);
                //     const dynamicFilter = new Function('stock', `return ${criteriaString};`);
                //     this.stockData = this.stockData.filter(stock => dynamicFilter(stock));
                //     console.log("Filtered Stock Data:", this.stockData);
                // } catch (error) {
                //     console.error("Error in dynamic filter function:", error);
                // }

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        async onStockDataTimePeriodChange() {
            this.loading = true;

            try {
                console.log("[Overview][onStockDataTimePeriodChange] Got here.");

                const timePeriodMap = {
                    "5": -5,
                    "10": -10,
                    "15": -15,
                    "20": -20,
                    "Maximum": -25
                };

                const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

                const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);

                const recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                console.log("[Overview][onStockDataStockHistoryOptionChange] recentYears = ", recentYears);

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                if (this.selectedStockDataStockHistoryOption === "EPS") {
                    selectedOption = "eps";
                    selectedLabel = "EPS";
                } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                    selectedOption = "lowSharePrice";
                    selectedLabel = "Low Price";

                } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                    selectedOption = "highSharePrice";
                    selectedLabel = "High Price";

                } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                    selectedOption = "averageSharePrice";
                    selectedLabel = "Average Price";

                } else {
                    selectedOption = "dividendPerShare";
                    selectedLabel = "Dividends Per Share";
                }

                console.log("[Overview][onStockDataStockHistoryOptionChange] this.selectedStockDataStockHistoryOption = ", this.selectedStockDataStockHistoryOption);
                console.log("[Overview][onStockDataStockHistoryOptionChange] selectedOption = ", selectedOption);

                if (selectedOption) {
                    // Set up lineData with the appropriate label and data based on the selected option code
                    this.lineData = {
                        labels: recentYears.map(item => item.year),
                        datasets: [
                            {
                                label: selectedLabel, // Use the name from the selected option
                                data: recentYears.map(item => item[selectedOption] != null ? item[selectedOption] : 0),
                                // data: recentYears.map(item => item[selectedOption]), // Access the data using the code as key
                                fill: false,
                                borderColor: '#42A5F5',
                                tension: 0.4
                            }
                        ]
                    };
                } else {
                    console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
                }

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Years'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }

        },
        async onStockDataStockHistoryOptionChange() {
            this.loading = true;

            try {
                console.log("[Overview][onStockDataStockHistoryOptionChange] Got here.");

                const timePeriodMap = {
                    "5": -5,
                    "10": -10,
                    "15": -15,
                    "20": -20,
                    "Maximum": -25
                };

                const sliceSize = timePeriodMap[this.selectedStockDataTimePeriod] || undefined;

                const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);

                const recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                console.log("[Overview][onStockDataStockHistoryOptionChange] recentYears = ", recentYears);

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                if (this.selectedStockDataStockHistoryOption === "EPS") {
                    selectedOption = "eps";
                    selectedLabel = "EPS";
                } else if (this.selectedStockDataStockHistoryOption === "LSP") {
                    selectedOption = "lowSharePrice";
                    selectedLabel = "Low Price";

                } else if (this.selectedStockDataStockHistoryOption === "HSP") {
                    selectedOption = "highSharePrice";
                    selectedLabel = "High Price";

                } else if (this.selectedStockDataStockHistoryOption === "ASP") {
                    selectedOption = "averageSharePrice";
                    selectedLabel = "Average Price";

                } else {
                    selectedOption = "dividendPerShare";
                    selectedLabel = "Dividends Per Share";
                }

                console.log("[Overview][onStockDataStockHistoryOptionChange] this.selectedStockDataStockHistoryOption = ", this.selectedStockDataStockHistoryOption);
                console.log("[Overview][onStockDataStockHistoryOptionChange] selectedOption = ", selectedOption);

                if (selectedOption) {
                    // Set up lineData with the appropriate label and data based on the selected option code
                    this.lineData = {
                        labels: recentYears.map(item => item.year),
                        datasets: [
                            {
                                label: selectedLabel, // Use the name from the selected option
                                data: recentYears.map(item => item[selectedOption] != null ? item[selectedOption] : 0),
                                // data: recentYears.map(item => item[selectedOption]), // Access the data using the code as key
                                fill: false,
                                borderColor: '#42A5F5',
                                tension: 0.4
                            }
                        ]
                    };
                } else {
                    console.warn("[Overview][onStockDataStockHistoryOptionChange] No matching option found for code:", this.selectedStockHistoryOptionCode);
                }

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Years'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        onToggleColumns(value) {
            console.log("[Plan][onToggleColumns] value = ", value);
            this.selectedColumns = [...value]; // Ensure reactivity
            this.selectedFormat = "Complete";
            console.log("[Plan][onToggleColumns] this.selectedColumns = ", this.selectedColumns);
            console.log("[Plan][onToggleColumns] this.columnConfig = ", this.columnConfig);
            this.activeTab = 4;
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        formatNumeric(value) {
            if (value) {
                return numeral(value).format('0,0'); // Returns a formatted string with thousand separators
            } else {
                return '0'; // Ensure consistency by returning a string
            }
        },
        formatString(value) {
            if (value) {
                const formattedValue = String(value).substring(0, 50);
                return formattedValue;
            } else {
                return '';
            }
        },
        getDividendTrap() {
            let averageDividendYieldTotal = 0;

            let combinedList = [];
            let topRankedList = [];
            let runnersUpList = [];

            if (this.selectedExchange === "JSE") {
                topRankedList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedJseCriteria);
                runnersUpList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.runnersUpJseCriteria);
            } else if (this.selectedExchange === "LSE") {
                topRankedList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
                runnersUpList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedLseCriteria);
            } else {
                topRankedList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
                runnersUpList = this.originalStockData.filter(stock => stock.siCriteriaYear20Id128 === this.topRankedNyseCriteria);
            }

            combinedList = [...topRankedList, ...runnersUpList];

            let totalDividendYield = combinedList.reduce((total, stock) => {
                return total + (stock.currentDividendYieldId050 || 0);
            }, 0);

            if (combinedList.length > 0) {
                averageDividendYieldTotal = totalDividendYield / combinedList.length;
            }

            this.averageDividendYield = averageDividendYieldTotal;
            this.maxDividendYield = this.averageDividendYield * 2.5;

        },
        async onCompanyCodeClick(inputStockData) {
            this.loading = true;

            try {
                this.activeTab = 6;
                this.specificStockData = inputStockData;
                this.specificStockDataArray = [inputStockData];

                try {
                    const [stockHistoryInfo] = await Promise.all([
                        StockHistoryService.getStockHistory(this.selectedExchange, inputStockData.codeId129)
                    ]);

                    this.stockHistory = stockHistoryInfo.data;
                    console.log("[Overview][mounted] this.stockHistory = ", this.stockHistory);

                    const sliceSize = -25;
                    const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);
                    this.stockHistory = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;


                } catch (e) {
                    console.error("[Overview][onCompanyCodeClick] Error fetching stock history data = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }

                const sliceSize = -20;

                const filteredStockHistory = this.stockHistory.filter(item => item.year !== 2024);

                const recentYears = sliceSize ? filteredStockHistory.slice(sliceSize) : filteredStockHistory;

                console.log("[Overview][onStockDataStockHistoryOptionChange] recentYears = ", recentYears);

                let selectedOption = "dividendPerShare";
                let selectedLabel = "Dividends Per Share";

                this.lineData = {
                    labels: recentYears.map(item => item.year),
                    datasets: [
                        {
                            label: selectedLabel, // Use the name from the selected option
                            data: recentYears.map(item => item[selectedOption]), // Access the data using the code as key
                            fill: false,
                            borderColor: '#42A5F5',
                            tension: 0.4
                        }
                    ]
                };

                this.lineOptions = {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        }
                    },
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Months'
                            }
                        },
                        y: {
                            display: true,
                            title: {
                                display: true,
                                text: 'Value'
                            }
                        }
                    }
                };

                console.log("this.specificStockData = ", this.specificStockData);
                this.loading = false;

            } finally {
                this.loading = false; // Hide the spinner
            }
        },
        async callWatchlist() {
            this.activeTab = 4;

            this.loading = true;

            if (this.exchanges.length > 0) {
                this.selectedExchange = this.exchanges[0].code;
            }

            console.log("[Plan][callWatchlist] this.selectedExchange = ", this.selectedExchange);

            const [watchlistInfo] = await Promise.all([
                WatchlistService.getUserWatchlists(this.userStore.user.id)
            ]);

            this.watchList = watchlistInfo.data;
            const normalizedExchange = this.selectedExchange.trim().toUpperCase();

            console.log("[Plan][callWatchlist] normalizedExchange = ", normalizedExchange);

            this.stockData = this.stockData.filter(stock =>
                this.watchList.some(item =>
                    stock.codeId129 === item.code &&
                    stock.exchangeId073?.trim().toUpperCase() === item.exchange?.trim().toUpperCase() &&
                    item.exchange?.trim().toUpperCase() === normalizedExchange
                )
            );

            this.loading = false;
        },
        // async callWatchlist() {
        //     this.activeTab = 4;
        //     this.loading = true;
        //
        //     console.log("[Plan][callWatchlist] this.selectedExchange = ", this.selectedExchange);
        //
        //     const [stockDataInfo, watchlistInfo] = await Promise.all([
        //         StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S'),
        //         WatchlistService.getUserWatchlists(this.userStore.user.id)
        //     ]);
        //
        //     this.stockData = stockDataInfo.data;
        //     this.originalStockData = stockDataInfo.data;
        //     this.watchList = watchlistInfo.data;
        //
        //     console.log("[Plan][callWatchlist] this.originalStockData = ", this.originalStockData);
        //
        //     let criteriaString = "";
        //
        //     this.watchList.forEach((item, index, array) => {
        //         if (index === array.length - 1) {
        //             console.log("This is the last element.");
        //             criteriaString = criteriaString + "stock.codeId129 === '" + item.code + "' ";
        //         } else {
        //             criteriaString = criteriaString + "stock.codeId129 === '" + item.code + "' || ";
        //         }
        //     });
        //
        //     criteriaString = criteriaString + "&& (stock.exchangeId073 === '" + this.selectedExchange + "') ";
        //
        //     try {
        //         console.log("[Plan][callWatchlist] criteriaString = ", criteriaString);
        //
        //         const dynamicFilter = new Function('stock', `return ${criteriaString};`);
        //         this.stockData = this.stockData.filter(stock => dynamicFilter(stock));
        //
        //         console.log("[Plan][callWatchlist] this.stockData (filtered) = ", this.stockData);
        //     } catch (error) {
        //         console.error("Error in dynamic filter function:", error);
        //     }
        //
        //     this.loading = false;
        //
        // },
        callWatchlistAdd() {
            this.activeTab = 7;
            this.selectedWatchlistCode = "";

            if (this.exchanges && this.exchanges.length > 0) {
                this.selectedWatchlistExchange = this.exchanges[0].code;
            }
        },
        async callWatchlistDelete() {
            this.activeTab = 8;

            const [watchlistInfo] = await Promise.all([
                WatchlistService.getUserWatchlists(this.userStore.user.id)
            ]);

            this.watchList = watchlistInfo.data;
        },
        callDeleteWatchlistItem(data) {
            this.existingWatchlistItem = data;
            this.activeTab = 9;
            this.confirmationResponse = "N";
        },
        async savePlanConfiguration() {
            this.submitted = true;
            this.loading = true;

            if (this.selectedWatchlistExchange) {

                try {
                    var newDataDto = {
                        siFreedomGoal: this.userConfiguration.siFreedomGoal,
                        siFreedomYear: this.userConfiguration.siFreedomYear,
                        siPlanCurrency: this.userConfiguration.siPlanCurrency
                    };

                    console.log('[Plan][savePlanConfiguration] this.userStore.user.id = ', this.userStore.user.id);
                    console.log('[Plan][savePlanConfiguration] newDataDto = ', newDataDto);

                    const response = await UserService.updateUserConfig(this.userStore.user.id, newDataDto);

                    try {
                        const [userConfigData] = await Promise.all([
                            UserService.getUserConfig(this.userStore.user.id)
                        ]);

                        this.userConfiguration = userConfigData.data;
                        console.log("[Plan][savePlanConfiguration] userConfigData.data = ", userConfigData.data);
                    } catch (e) {
                        console.error("[Plan][savePlanConfiguration] Could not find user config for user = ", this.userStore.user.id);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;

                    }

                    console.log('[Plan][savePlanConfiguration] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated plan information',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Plan][savePlanConfiguration] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update plan information. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 3;
            this.submitted = false;
            this.loading = true;

        },
        async saveWatchlistItem() {
            this.submitted = true;
            this.loading = true;

            console.log('[Plan][saveWatchlistItem] this.selectedWatchlistExchange = ', this.selectedWatchlistExchange);
            console.log('[Plan][saveWatchlistItem] this.selectedWatchlistCode = ', this.selectedWatchlistCode);
            console.log('[Plan][saveWatchlistItem] this.selectedWatchlistCode.value = ', this.selectedWatchlistCode.value);

            if (this.selectedWatchlistExchange) {

                try {
                    var newDataDto = {
                        exchange: this.selectedWatchlistExchange,
                        code: this.selectedWatchlistCode.value
                    };

                    console.log('[Plan][saveWatchlistItem] this.userStore.user.id = ', this.userStore.user.id);
                    console.log('[Plan][saveWatchlistItem] newDataDto = ', newDataDto);

                    const response = await WatchlistService.createWatchlist(this.userStore.user.id, newDataDto);

                    console.log('[Plan][saveWatchlistItem] Response = ', response);

                    const [stockDataInfo, watchlistInfo] = await Promise.all([
                        StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S'),
                        WatchlistService.getUserWatchlists(this.userStore.user.id)
                    ]);

                    this.stockData = stockDataInfo.data;
                    this.originalStockData = stockDataInfo.data;
                    this.watchList = watchlistInfo.data;

                    console.log("[Plan][saveWatchlistItem] this.originalStockData = ", this.originalStockData);

                    const normalizedExchange = this.selectedExchange.trim().toUpperCase();

                    console.log("[Plan][saveWatchlistItem] normalizedExchange = ", normalizedExchange);

                    // Filter stock data based on watchlist and exchange
                    this.stockData = this.stockData.filter(stock =>
                        // Match stock codes with watchlist items and their exchange value
                        this.watchList.some(item =>
                            stock.codeId129 === item.code &&
                            stock.exchangeId073?.trim().toUpperCase() === item.exchange?.trim().toUpperCase() &&
                            item.exchange?.trim().toUpperCase() === normalizedExchange
                        )
                    );

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created watchlist item',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Plan][saveWatchlistItem] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create watchlist item. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;

                }
            }

            this.activeTab = 4;
            this.submitted = false;
            this.loading = false;

        },
        async deleteWatchlistItem() {
            this.submitted = true;
            this.loading = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.existingWatchlistItem.id) {

                    try {
                        const response = await WatchlistService.deleteWatchlist(this.existingWatchlistItem.id);
                        console.log('[Plan][deleteWatchlistItem] Response = ', response);

                        const [stockDataInfo, watchlistInfo] = await Promise.all([
                            StockDataService.getAllStockDataForExchange(this.selectedExchange, 'S'),
                            WatchlistService.getUserWatchlists(this.userStore.user.id)
                        ]);

                        this.stockData = stockDataInfo.data;
                        this.originalStockData = stockDataInfo.data;
                        this.watchList = watchlistInfo.data;

                        console.log("[Plan][deleteWatchlistItem] this.originalStockData = ", this.originalStockData);

                        const normalizedExchange = this.selectedExchange.trim().toUpperCase();

                        console.log("[Plan][deleteWatchlistItem] normalizedExchange = ", normalizedExchange);

                        // Filter stock data based on watchlist and exchange
                        this.stockData = this.stockData.filter(stock =>
                            // Match stock codes with watchlist items and their exchange value
                            this.watchList.some(item =>
                                stock.codeId129 === item.code &&
                                stock.exchangeId073?.trim().toUpperCase() === item.exchange?.trim().toUpperCase() &&
                                item.exchange?.trim().toUpperCase() === normalizedExchange
                            )
                        );

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted watchlist item',
                            life: 3000
                        });
                    } catch (e) {
                        console.error('[Plan][deleteWatchlistItem] Error:', e);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete watchlist item. Please try again.',
                            life: 3000
                        });

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;

                    }
                }

                this.activeTab = 8;
                this.submitted = false;
                this.loading = false;

            }
        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
}

.highlight {
    background-color: #7cd9d1; /* Example: light red */
    color: black; /* Text color */
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-DT {
        background: #E5C7BCFF;
        color: #BE5306FF;
    }
}
</style>
